import { ChangeDetectorRef, Component, EventEmitter, HostListener, Input, Output } from "@angular/core";

import { CalendarDirective } from "../calendar.directive";

@Component({
  selector: "ui-day",
  // eslint-disable-next-line prettier/prettier
  template: `<span>{{ day | date: "dd" }}</span>
`,
  host: {
    class: "ds-day",
    "[class.ds-is-selected]": "isSelected",
    "[class.ds-is-disabled]": "isDisabled",
    "[class.ds-invisible]": "isHidden",
    "[attr.tabindex]": "isDisabled ? '-1' : '0'",
  },
})
export class DayComponent extends CalendarDirective {
  @Input() day!: Date;
  /**
   * If the day is hidden from the view (i.e not belonging to the current month view)
   */
  @Input() isHidden!: boolean;
  /**
   * If the day is disabled (ex outside min|max dates in the calenar)
   */
  @Input() isDisabled!: boolean;
  /**
   * Marks the day as selected
   */
  @Input() isSelected!: boolean;

  @Output() readonly selectedDayChange: EventEmitter<Date> = new EventEmitter<Date>();

  constructor(changeDetectorRef: ChangeDetectorRef) {
    super(changeDetectorRef);
  }

  /**
   * Emits the day as selected.
   */
  @HostListener("click") onClick() {
    this.selectedDayChange.emit(this.day);
  }
  @HostListener("keydown.enter") onKeydownHandler() {
    this.selectedDayChange.emit(this.day);
  }
}
